var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return true
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "my-5",
            attrs: {
              role: "menu",
              "aria-orientation": "vertical",
              "aria-labelledby": "menu-button",
              tabindex: "-1",
              id: "filter-form",
            },
          },
          [
            _c(
              "div",
              [
                _vm.showProjects
                  ? _c(
                      "FormGroup",
                      {
                        staticClass: "mb-5 from-group",
                        attrs: { title: "Client Name" },
                      },
                      [
                        _c("ProjectsMultiselect", {
                          attrs: {
                            value: _vm.selectedProjectsIds,
                            placeholder: "Select Client",
                            max: 5,
                            selectedInline: "",
                            withoutLoading: "",
                          },
                          on: {
                            "input:id_names": _vm.updateFiltersSelectedProjects,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "grid grid-cols-2 gap-6" },
                  [
                    _c(
                      "FormGroup",
                      {
                        staticClass: "from-group",
                        attrs: { title: "Client Criteria" },
                      },
                      [
                        _c("ProjectCriteriaMultiselect", {
                          attrs: { isManager: _vm.isManager },
                          model: {
                            value: _vm.filterFields.criteria,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterFields, "criteria", $$v)
                            },
                            expression: "filterFields.criteria",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "FormGroup",
                      {
                        staticClass: "from-group",
                        attrs: { title: "Client Status" },
                      },
                      [
                        _c("ProjectStatusSelect", {
                          model: {
                            value: _vm.filterFields.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterFields, "status", $$v)
                            },
                            expression: "filterFields.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex justify-end pt-5" },
              [
                _c("UIButton", {
                  staticClass: "mr-3",
                  attrs: {
                    variant: "outline",
                    buttonText: "Reset",
                    size: "sm",
                  },
                  on: { click: _vm.clearFilters },
                }),
                _c("UIButton", {
                  attrs: {
                    buttonText: "Apply Filters",
                    size: "sm",
                    variant: "black",
                  },
                  on: { click: _vm.applyFilters },
                }),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }